export type OutputType = {
  tier: string;
  status: string;
  isTrialing: boolean;
  trialEnd: string | null;
  currentPeriodEnd: string | null;
  cancelAtPeriodEnd: boolean;
  isUnlimited: boolean;
};

export const getSubscriptionStatus = async (init?: RequestInit): Promise<OutputType> => {
  const result = await fetch('/_api/subscription/status', {
    method: 'GET',
    credentials: 'include',
    ...init,
    headers: { 'Content-Type': 'application/json', ...(init?.headers ?? {}) },
  });
  if (!result.ok) throw new Error('Failed to fetch subscription status');
  return result.json();
};
